// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1r0KB","right":"styles_right__1oR5-"};